import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GroupHeader, GroupWrapper } from 'src/domains/layouts/webview/components/debugPanel/DebugPanel.style';
import { RTLGameDetails } from './RTLGameDetails';
import { CollectionType } from 'src_common/playwright/types/casino/categoriesAndGamesResponse';
import { AppCasinoState } from 'src/domains/casino/state/AppCasino.state';
import { useCommon } from 'src/domains/common/Common';

interface PropsType {
    collection: CollectionType | null;
    tabId: string | null;
}

export const RTLDebug = observer('RTLDebug', ({ collection, tabId }: PropsType) => {
    const common = useCommon();
    const appCasinoState = AppCasinoState.get(common);

    if (collection === null) {
        return <span>Open collection page (virtuals | casino | live-casino).</span>;
    }

    const casinoPageState = appCasinoState.casinoPageState.get(collection).get(tabId);

    if (collection !== 'virtuals' && casinoPageState.navigationState.isHomeActive) {
        return <span>Casino Home. Open any category.</span>;
    }

    const gameModels =
        collection === 'virtuals'
            ? casinoPageState.navigationState.gamesListToDisplayNonCategorized
            : casinoPageState.navigationState.gamesListToDisplay;

    if (gameModels === 'loading') {
        return <span>Loading...</span>;
    }

    return (
        <>
            <GroupWrapper>
                <GroupHeader>
                    Collection: {collection} | TabId: {tabId}
                </GroupHeader>
            </GroupWrapper>

            {gameModels.map((gameModel) => {
                return (
                    <RTLGameDetails
                        key={gameModel.id}
                        gameModel={gameModel}
                    />
                );
            })}
        </>
    );
});
